module.exports = __webpack_public_path__ + "static/media/FarmCup_RewardBackground.8fba32e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/reward-background/FarmCup_RewardBackground.png
// module id = 1358
// module chunks = 3